// Slightly faster cart updates while still keeping a small debounce.
// (The cart UI is also locked immediately on quantity changes in cart.js.)
const ON_CHANGE_DEBOUNCE_TIMER = 200;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
